import { useCallback } from "react";
import { useNotify } from "react-admin";
import { useDropzone } from "react-dropzone";
import "react-dropzone/examples/theme.css";

interface ICsvFileUploadInput {
  setValues: (value: any) => void;
  commercialDocumentType: string;
  isHaveNullableField?: boolean;
}

const CsvFileUploadInput = ({
  setValues,
  commercialDocumentType,
  isHaveNullableField,
}: ICsvFileUploadInput) => {
  const notify = useNotify();

  const getRowLength = (type: string) => {
    switch (type) {
      case "invoice":
        return 8;
      case "credit_note":
        return 8;
      default:
        return 0;
    }
  };

  const onDrop = useCallback((acceptedFiles) => {
    acceptedFiles.forEach((file: any) => {
      const reader = new FileReader();

      reader.onload = () => {
        //get the first row
        var labels: any = (reader.result as string).split("\r\n").shift();
        //get all row
        var items: any = (reader.result as string).split("\r\n");
        //split each column in row into array
        var label = labels.split(",");
        //remove first row
        items.splice(0, 1);

        let values: any = [];
        let cleanItems: any = [];

        if (label.length !== getRowLength(commercialDocumentType)) {
          notify(
            "Your CSV is invalid, please use the new version of csv",
            "warning"
          );
          return;
        }

        // cleaning the items from empty string
        items.forEach((record: string) => {
          // split a string by commas but ignore commas within double-quotes
          const splitRecord = record.split(",");

          // only insert if not have empty string;
          if (splitRecord[0] !== "") {
            cleanItems.push(record);
          }
        });

        if (cleanItems.length > 50) {
          notify("Please upload less than 50 records", "warning");
          return;
        }

        cleanItems.forEach((record: string) => {
          // split a string by commas but ignore commas within double-quotes
          const splitedRecord = record
            .split(/(?:([^",]+?)|"(.+?)") *, */)
            .filter((e) => e);

          if (splitedRecord.length === getRowLength(commercialDocumentType)) {
            let dataToInsert: any = {};
            let isGoForInsert = true;

            label.forEach((labelItem: string, index: number) => {
              if (!isHaveNullableField) {
                if (splitedRecord[index] === "") {
                  isGoForInsert = false;
                }
              }

              dataToInsert[labelItem] =
                splitedRecord[index] === "" ? null : splitedRecord[index];
            });

            if (isGoForInsert) {
              dataToInsert.status = "Loading...";
              values.push(dataToInsert);
            }
          } else {
            notify(
              `Record data and Column is not have matching length`,
              "warning"
            );
            return;
          }
        });

        setValues(values);
      };
      reader.readAsText(file);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    multiple: false,
    accept: ".csv",
    onDrop,
  });

  return (
    <div {...getRootProps({ className: "dropzone" })}>
      <input {...getInputProps()} />
      <p>Drag 'n' drop a CSV file here, or click to select files</p>
    </div>
  );
};

export default CsvFileUploadInput;
